/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
:host {
  display: block;
  height: 100%;
  left: 0;
  overflow: hidden;
  pointer-events: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 3999;
}

:host([status=opening]) {
  opacity: 0;
}

:host([status=opened]) {
  opacity: 1;
  transition: opacity 250ms ease-out;
}

:host([status=closing]) {
  opacity: 0;
  transition: opacity 250ms ease-out;
}

:host([status=closed]) {
  opacity: 0;
  display: none;
}

.container {
  display: block;
  background-color: white;
  text-align: center;
  width: 90%;
  padding: 30px;
}
@media (width >= 768px) {
  .container {
    padding: 50px;
    width: 83.3333%;
  }
}
@media (width >= 1024px) {
  .container {
    max-width: 960px;
    width: 66.6666%;
    padding: 50px;
  }
}
.container ux-loader {
  left: 0;
  transform: inherit;
}

.backdrop {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.headline {
  margin-top: 0;
  margin-bottom: 20px;
}
.headline:empty {
  display: none;
}

.subline {
  color: #727272;
  margin-top: 25px;
  margin-bottom: 0;
}
.subline:empty {
  display: none;
}

.loader {
  display: block;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

h2 {
  font-family: Frutiger-Light, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
}

p {
  font-family: Frutiger-Light, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  font-size: var(--ux-text-font-size-normal);
  line-height: var(--ux-text-line-height-normal);
}